import { API_ROUTES } from '@/common/constants'

export function shouldSendAccountIdHeader(requestUrl?: string, method?: string) {
    const normalizedRequestUrl = requestUrl?.split('?')[0]
    const normalizedMethod = (method || 'get').toLowerCase()

    const isUserFetchRequest = normalizedMethod === 'get' && normalizedRequestUrl === API_ROUTES.user
    const isAccountScopedRequest =
        normalizedRequestUrl === API_ROUTES.accounts || normalizedRequestUrl?.startsWith(`${API_ROUTES.accounts}/`)
    const routesWithoutAccountId = [API_ROUTES.userRewards, API_ROUTES.addressSearch, API_ROUTES.addressSearchById]
    const isRouteWithoutAccountId = routesWithoutAccountId.includes(normalizedRequestUrl ?? '')

    return !(isUserFetchRequest || isAccountScopedRequest || isRouteWithoutAccountId)
}

export function syncAccountIdHeader(
    headers: Record<string, unknown>,
    requestUrl?: string,
    method?: string,
    accountId?: string | null,
) {
    delete headers['x-account-id']

    if (accountId && shouldSendAccountIdHeader(requestUrl, method)) {
        headers['x-account-id'] = accountId
    }

    return headers
}
